var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-outage-result__planned",
      class: {
        "c-outage-result__planned--list-view": _vm.outagePageView === "list",
      },
    },
    [
      _c("div", {
        staticClass: "c-outage-result__planned-triangle",
        class: {
          "c-outage-result__planned-triangle--cancelled":
            _vm.outage.status == "Cancelled",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "c-outage-result__wrapper" }, [
        _c("img", {
          staticClass: "c-outage-result__graphic",
          attrs: { src: _vm.getMarkerIcon(_vm.outage) },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "c-outage-result__details" }, [
          _c("p", { staticClass: "c-outage-result__outage-number" }, [
            _vm._v(
              "\n        " +
                _vm._s("#" + _vm.outage.distributorEventNumber) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "c-outage-result__outage-title" }, [
            _c("a", { attrs: { href: _vm.outage.link } }, [
              _vm._v(
                "\n          " + _vm._s(_vm.outage.suburbsText) + "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "c-outage-result__outage-type" }, [
            _vm.outage.status != "Cancelled"
              ? _c("span", [_vm._v("Planned outage")])
              : _c(
                  "span",
                  { staticClass: "c-outage-result__outage-type-cancelled" },
                  [_vm._v("Planned outage")]
                ),
            _vm._v(" "),
            _vm.outage.status == "Cancelled"
              ? _c(
                  "span",
                  { staticClass: "c-outage-result__outage-cancelled" },
                  [_vm._v("Cancelled")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.outage.useAlternateDate
              ? _c(
                  "span",
                  {
                    staticClass:
                      "c-outage-result__outage-alternate-date-wrapper",
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "c-outage-result__outage-alternate-date",
                        class: {
                          "c-outage-result__outage-alternate-date--strike":
                            _vm.outage.status == "Cancelled",
                        },
                      },
                      [_vm._v("Alternative date in use")]
                    ),
                    _vm._v(" "),
                    _c("outage-tooltip", {
                      staticClass: "c-outages-nav__filter-tooltip",
                      attrs: {
                        "tooltip-content": _vm.cmsContent.alternateDateContent,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-outage-result__details-holder" }, [
            _c(
              "div",
              { staticClass: "c-outage-result__details-times" },
              [
                _vm.outage.useAlternateDate
                  ? [
                      _c(
                        "p",
                        {
                          staticClass: "c-outage-result__start-time",
                          class: {
                            "c-outage-result__start-time--cancelled":
                              _vm.outage.status == "Cancelled",
                          },
                        },
                        [
                          _vm._v(
                            "\n              New scheduled start date/time:\n              "
                          ),
                          _c("span", { staticClass: "c-outage-result__bold" }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatDate(
                                  _vm.outage.alternateStartDateTime
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "c-outage-result__end-time",
                          class: {
                            "c-outage-result__end-time--cancelled":
                              _vm.outage.status == "Cancelled",
                          },
                        },
                        [
                          _vm._v(
                            "\n              New scheduled end date/time:\n              "
                          ),
                          _c("span", { staticClass: "c-outage-result__bold" }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatDate(_vm.outage.alternateEndDateTime)
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  : [
                      _c(
                        "p",
                        {
                          staticClass: "c-outage-result__start-time",
                          class: {
                            "c-outage-result__start-time--cancelled":
                              _vm.outage.status == "Cancelled",
                          },
                        },
                        [
                          _vm._v(
                            "\n              Scheduled start date/time:\n              "
                          ),
                          _c("span", { staticClass: "c-outage-result__bold" }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatDate(_vm.outage.outageStartDateTime)
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "c-outage-result__end-time",
                          class: {
                            "c-outage-result__end-time--cancelled":
                              _vm.outage.status == "Cancelled",
                          },
                        },
                        [
                          _vm._v(
                            "\n              Scheduled end date/time:\n              "
                          ),
                          _c("span", { staticClass: "c-outage-result__bold" }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatDate(_vm.outage.outageEndDateTime)
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.outage.alternateDate
                        ? _c(
                            "p",
                            {
                              staticClass: "c-outage-result__alternate-date",
                              class: {
                                "c-outage-result__alternate-date--cancelled":
                                  _vm.outage.status == "Cancelled",
                              },
                            },
                            [
                              _vm._v(
                                "\n              Alternative date:\n              "
                              ),
                              _c(
                                "span",
                                { staticClass: "c-outage-result__bold" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formatDate(
                                          _vm.outage.alternateDate,
                                          false
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "c-outage-result__additional-details" }, [
              _vm.outagePageView === "list"
                ? _c("div", [
                    _c("p", {}, [
                      _vm._v(
                        "\n              Customers affected:\n              "
                      ),
                      _c("span", { staticClass: "c-outage-result__bold" }, [
                        _vm._v(_vm._s(_vm.outage.customersAffected)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", {}, [
                      _vm._v(
                        "\n              Reason for outage:\n              "
                      ),
                      _c("span", { staticClass: "c-outage-result__bold" }, [
                        _vm._v(_vm._s(_vm.outage.reasonForOutage)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.outage.status == "Cancelled"
                      ? _c("p", {}, [
                          _vm._v(
                            "\n              Reason for cancellation:\n              "
                          ),
                          _vm.outage.reasonForCancellation
                            ? _c(
                                "span",
                                { staticClass: "c-outage-result__bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm.outage.reasonForCancellation
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _c(
                                "span",
                                { staticClass: "c-outage-result__bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm.cmsContent
                                          .defaultReasonForCancellation
                                      )
                                    )
                                  ),
                                ]
                              ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "c-outage-result__link",
              attrs: { href: _vm.outage.link },
            },
            [
              _vm._v("More details"),
              _c("span", [
                _c("img", {
                  attrs: {
                    src: "_resources/app/client/assets/icons/outages-map/more-details-arrow.svg",
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.outagePageView == "map"
            ? _c(
                "span",
                {
                  staticClass: "c-outage-result__zoom",
                  on: {
                    click: function ($event) {
                      return _vm.zoomToMap(_vm.outage)
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: "_resources/app/client/assets/icons/outages-map/map-icon.svg",
                    },
                  }),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }